import { createMetadata } from 'supporticon/api/metadata'
import { metadataAPI } from 'supporticon/utils/client'
import { isStaging } from '../environment'

const getAppId = () =>
  isStaging() ? process.env.MDS_JG_STAGING_APP_ID : process.env.MDS_JG_PROD_APP_ID

const deletePageMetadata = ({ authType = 'Bearer', page, token }) =>
  metadataAPI.delete(`/v1/apps/${getAppId()}/pages/${page}/metadata`, {
    headers: { Authorization: [authType, token].join(' ') }
  })

export const createPageMetadata = ({
  authType = 'Bearer',
  metadata,
  page,
  token
}) =>
  deletePageMetadata({ authType, page, token })
    .then(() =>
      createMetadata({
        app: getAppId(),
        authType,
        id: page,
        metadata,
        token
      })
    )
